import { forwardRef, Suspense } from 'react';
import { bitwiseRoundOff } from '../../../Utils/CommonUtils';
import get from 'lodash.get';
import { TPricingPlans } from '../../../S/pricing/types';
import { startFilingLink } from '../../static/data';
import { DEFAULT_NAV_PROPS } from '../../static/types';
import { ApiPlan } from '../hero-section/view-new-plan-modal-content/types';
import dynamic from 'next/dynamic';

const StartForFreeBanner = dynamic(
  () => import('./start-for-free').then((mod) => mod.StartForFreeBanner),
  { suspense: true }
);

interface StartForFreeProps extends DEFAULT_NAV_PROPS {
  priceMapData: Record<string, TPricingPlans>;
  planId: string;
  plans: ApiPlan[];
}

export const StartForFreeSection: React.FC<StartForFreeProps> = forwardRef(
  (
    { id, priceMapData, planId, plans },
    ref: React.ForwardedRef<HTMLDivElement>
  ): JSX.Element => {
    const capitalGainPlanData =
      plans?.filter((plan) => plan.id === planId) || [];
    const discountedPriceValue = Number(
      get(capitalGainPlanData[0], 'incomeBrackets[0].discountedAmount', '0')
    );
    const listPrice = Number(
      get(capitalGainPlanData[0], 'incomeBrackets[0].originalAmount', '0')
    );

    return (
      <div className="bg-white" data-testid={id} id={id} ref={ref}>
        <div className="wg-container pt-28 md:pt-16 sm:pt-16">
          <Suspense fallback={<div>Loading Pricing...</div>}>
            <StartForFreeBanner
              priceMapData={priceMapData}
              heading="Start filing now, Pay later!"
              desc="We'll auto select your plan basis on your ITR info. Pay later at checkout"
              planData={{
                text: 'Our Plans starting from ',
                discountedPrice: `₹${bitwiseRoundOff(discountedPriceValue)}`,
                originalPrice: `₹${listPrice}`,
              }}
              button1={{
                text: 'File now',
                url: startFilingLink,
              }}
              button2={{
                text: 'Explore Plans',
                url: startFilingLink,
              }}
              plans={plans}
            />
          </Suspense>
        </div>
      </div>
    );
  }
);

StartForFreeSection.displayName = 'StartForFreeSection';
